module.exports = "/img/caret-left.svg?32071803f30bdf127bb424ceb57adbb7";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/caret-left.svg
// module id = +Oi8
// module chunks = 80